// Vendor
import { EventEmitter, SimpleChanges } from '@angular/core';
// Components
import { METRIC_ALERT_ACTIONS_CONFIG } from 'AlertsApp/ts/features/alerts-modals/constants';
import { SharingService } from 'SharingApp/ts/services/sharing.service';
import * as i0 from "@angular/core";
import * as i1 from "SharingApp/ts/services/sharing.service";
import * as i2 from "@angular/common";
import * as i3 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i4 from "../../../../../../../../../ycharts/static/ts/features/components/dropdowns/simple-dropdown/simple-dropdown.component";
import * as i5 from "../../../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
const _c0 = ["ycn-metric-alerts-list-item", ""];
const _c1 = a0 => ({ "text-gray-60": a0 });
function MetricAlertsListItemComponent_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 8);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 6);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("tooltipHtml", true)("tooltipPlacement", "bottom")("tooltipTitle", ctx_r0.alertSharedTooltipText);
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-team");
} }
function MetricAlertsListItemComponent_ng_container_5_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0, "1 Note");
} }
function MetricAlertsListItemComponent_ng_container_5_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtext(0);
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate1("", ctx_r0.alert.notes.length, " Notes");
} }
function MetricAlertsListItemComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, " \u00A0 ");
    i0.ɵɵelementStart(2, "a", 9);
    i0.ɵɵlistener("click", function MetricAlertsListItemComponent_ng_container_5_Template_a_click_2_listener() { i0.ɵɵrestoreView(_r2); const ctx_r0 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r0.openNotesModal.emit(ctx_r0.alert)); });
    i0.ɵɵelementStart(3, "span", 10);
    i0.ɵɵtemplate(4, MetricAlertsListItemComponent_ng_container_5_ng_template_4_Template, 1, 0, "ng-template", 11)(5, MetricAlertsListItemComponent_ng_container_5_ng_template_5_Template, 1, 1, "ng-template", 12);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(6, "svg", 6);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("tooltipPlacement", "bottom")("tooltipTitle", ctx_r0.tooltipText);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngPlural", ctx_r0.alert.notes.length);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("name", "icon-notes");
} }
/**
 * MetricAlertsListItemComponent.
 *
 * Metric alert created by the user.
 *
 */
export class MetricAlertsListItemComponent {
    constructor(sharingService) {
        this.sharingService = sharingService;
        this.deleteButtonHandler = new EventEmitter();
        this.shareButtonHandler = new EventEmitter();
        this.disableButtonHandler = new EventEmitter();
        this.openNotesModal = new EventEmitter();
        this.actionsDropdownConfig = METRIC_ALERT_ACTIONS_CONFIG;
        this.tooltipText = '';
        this.isAlertShared = false;
        this.isAlertDisabled = false;
        this.alertSharedTooltipText = '';
    }
    ngOnChanges(changes) {
        if (changes.alert) {
            const newAlert = changes.alert.currentValue;
            const sharingInfo = newAlert.sharing;
            this.tooltipText = this.getNoteTooltipText(newAlert);
            this.actionsDropdownConfig = this.getDropdownConfig(newAlert);
            this.isAlertDisabled = !!newAlert.disabled_alert_preference_id;
            this.isAlertShared = sharingInfo ? this.sharingService.isSharedWithOthers(newAlert) : false;
            this.alertSharedTooltipText = sharingInfo ? this.sharingService.getSharingTooltipMessage(newAlert) : '';
        }
    }
    getNoteTooltipText(alert) {
        if (alert.notes.length === 0) {
            return '';
        }
        if (alert.notes.length > 1) {
            return `${alert.notes.length} Notes`;
        }
        let noteContent = alert.notes[0].content;
        if (noteContent.length > 180) {
            noteContent = `${noteContent.slice(0, 180)}...`;
        }
        return noteContent;
    }
    getDropdownConfig(alert) {
        const hasShareAccess = alert.underlying_object_shared_or_not_shareable;
        const isAlertOwner = alert.sharing.is_owner;
        const isAlertDisabled = !!alert.disabled_alert_preference_id;
        const updatedDropdownListItems = METRIC_ALERT_ACTIONS_CONFIG.list.map((option) => {
            switch (option.value) {
                case 'share':
                    return { ...option, disabled: !hasShareAccess || !isAlertOwner };
                case 'delete':
                    return { ...option, disabled: !isAlertOwner };
                case 'toggleDisabled':
                    const icon = isAlertDisabled ? 'icon-password-show' : 'icon-password-no-show';
                    const label = isAlertDisabled ? 'Enable' : 'Disable';
                    return { ...option, icon, label };
                default:
                    return option;
            }
        });
        return { title: METRIC_ALERT_ACTIONS_CONFIG.title, list: updatedDropdownListItems };
    }
    selectDropdownOption(selectedItem) {
        switch (selectedItem) {
            case 'delete':
                this.deleteButtonHandler.emit(this.alert);
                break;
            case 'toggleDisabled':
                this.disableButtonHandler.emit(this.alert);
                break;
            case 'share':
                this.shareButtonHandler.emit(this.alert);
                break;
            default:
                break;
        }
    }
}
MetricAlertsListItemComponent.ɵfac = function MetricAlertsListItemComponent_Factory(t) { return new (t || MetricAlertsListItemComponent)(i0.ɵɵdirectiveInject(i1.SharingService)); };
MetricAlertsListItemComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: MetricAlertsListItemComponent, selectors: [["tr", "ycn-metric-alerts-list-item", ""]], inputs: { alert: "alert" }, outputs: { deleteButtonHandler: "deleteButtonHandler", shareButtonHandler: "shareButtonHandler", disableButtonHandler: "disableButtonHandler", openNotesModal: "openNotesModal" }, features: [i0.ɵɵNgOnChangesFeature], attrs: _c0, decls: 11, vars: 14, consts: [[1, "note-text"], ["data-test-id", "alert-name-description", 3, "ngClass"], ["ycnTooltip", "", "data-test-id", "alert-shared-tooltip", 3, "tooltipHtml", "tooltipPlacement", "tooltipTitle", 4, "ngIf"], [4, "ngIf"], [1, "note-controls", "text-right"], ["ycnTooltip", "", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", 3, "click", "tooltipPlacement", "tooltipTitle"], ["ycnIcon", "", 3, "name"], [1, "dropdown", 3, "handler", "buttonClass", "config", "dropdownClass", "tooltipText"], ["ycnTooltip", "", "data-test-id", "alert-shared-tooltip", 3, "tooltipHtml", "tooltipPlacement", "tooltipTitle"], ["href", "javascript:void(0)", "ycnTooltip", "", 1, "badge", "bg-yc-blue-90", "border-gray-base-90", 3, "click", "tooltipPlacement", "tooltipTitle"], [3, "ngPlural"], ["ngPluralCase", "=1"], ["ngPluralCase", "other"]], template: function MetricAlertsListItemComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "td")(1, "div", 0)(2, "span", 1);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, MetricAlertsListItemComponent_span_4_Template, 2, 4, "span", 2)(5, MetricAlertsListItemComponent_ng_container_5_Template, 7, 4, "ng-container", 3);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(6, "td")(7, "div", 4)(8, "div", 5);
        i0.ɵɵlistener("click", function MetricAlertsListItemComponent_Template_div_click_8_listener() { return ctx.openNotesModal.emit(ctx.alert); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(9, "svg", 6);
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(10, "ycn-simple-dropdown", 7);
        i0.ɵɵlistener("handler", function MetricAlertsListItemComponent_Template_ycn_simple_dropdown_handler_10_listener($event) { return ctx.selectDropdownOption($event); });
        i0.ɵɵelementEnd()()();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c1, ctx.isAlertDisabled));
        i0.ɵɵadvance();
        i0.ɵɵtextInterpolate2(" Alert me when ", ctx.alert.object_name, "'s ", ctx.alert.description, " ");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.isAlertShared);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.alert.notes !== undefined && ctx.alert.notes.length > 0);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("tooltipPlacement", "bottom")("tooltipTitle", "Create Notes");
        i0.ɵɵadvance();
        i0.ɵɵproperty("name", "icon-notes-add");
        i0.ɵɵadvance();
        i0.ɵɵproperty("buttonClass", "btn btn-xs btn-circle btn-transparent")("config", ctx.actionsDropdownConfig)("dropdownClass", "dropdown-menu-with-icons dropdown-menu-right")("tooltipText", "More");
    } }, dependencies: [i2.NgClass, i2.NgIf, i2.NgPlural, i2.NgPluralCase, i3.IconDirective, i4.SimpleDropdownComponent, i5.TooltipDirective], encapsulation: 2 });
